import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { DriversService } from '../../drivers-service/drivers-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-driver-shift-override',
  templateUrl: './driver-shift-override.component.html',
  styleUrls: ['./driver-shift-override.component.css']
})
export class DriverShiftOverrideComponent implements OnInit, OnDestroy {
  user;
  driverList: any = [];
  driverId: any;
  shiftId: any;
  shiftOverrideForm: FormGroup;
  isAllowToView = false;

  constructor(private fb: FormBuilder, private sharedDataService: SharedDataService, private activatedRoute: ActivatedRoute, private driverService: DriversService, private router: Router) { }

  ngOnInit() {
    if (this.activatedRoute.snapshot.url[0].path === 'timelines'){
      this.isAllowToView = true;
    }

    if (this.activatedRoute.snapshot.url.length === 4) {
      this.shiftId = this.activatedRoute.snapshot.url[2].path;
    } else if (this.activatedRoute.snapshot.url.length === 5) {
      this.driverId = this.activatedRoute.snapshot.url[2].path;
    } else if (this.activatedRoute.snapshot.url.length === 6) {
      this.driverId = this.activatedRoute.snapshot.url[2].path;
      this.shiftId = this.activatedRoute.snapshot.url[4].path;
    }

    if (this.shiftId) {
      this.getShiftById();
    }

    this.shiftOverrideForm = this.fb.group({
      driver: [''],
      dateOfService: [moment().startOf('day').toISOString()],
      isEnabled: [false],
      status:['active', Validators.required],
      shift: this.fb.group({
        preCheckin: [moment().startOf('day').toISOString()],
        preCheckout: [moment().endOf('day').toISOString()],
        checkin: [moment().startOf('day').format("HH:mm"), Validators.required],
        checkout: [moment().endOf('day').format("HH:mm"), Validators.required],
      })
    });

    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.driverId) {
            this.shiftOverrideForm.patchValue({
              driver: this.driverId
            });
          }

          this.getDrivers();
        }
      });
  }

  getDrivers() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getShiftById() {
    this.driverService.getShiftOverrideById(this.shiftId).pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (data) {
          const mCheckin = data.shift.checkin.split(":");
          const mCheckout = data.shift.checkout.split(":");

          console.log(mCheckin, mCheckout);
          this.shiftOverrideForm.patchValue({
            ...data,
            shift: {
              ...data.shift,
              preCheckin: moment().startOf('day').hours(mCheckin[0]).minutes(mCheckin[1]).seconds(0).toISOString(),
              preCheckout: moment().startOf('day').hours(mCheckout[0]).minutes(mCheckout[1]).seconds(0).toISOString()
            }
          });
        }
      });
  }

  get shiftForm() {
    return this.shiftOverrideForm.controls.shift as FormGroup;
  }

  get form() {
    return this.shiftOverrideForm.controls;
  }

  onChangeShiftStart(event: any) {
    const shift = this.shiftOverrideForm.get('shift') as FormGroup;
    shift.patchValue({
      checkin: moment(event).format('HH:mm')
    });

    // Auto-adjust end if invalid
    if (moment(event).isAfter(shift.value.preCheckout)) {
      shift.patchValue({
        checkout: moment(event).format('HH:mm')
      });
    }
  }

  onChangeShiftEnd(event: any) {
    const shift = this.shiftOverrideForm.get('shift') as FormGroup;
    shift.patchValue({
      checkout: moment(event).format('HH:mm')
    });

    // Auto-adjust start if invalid
    if (moment(event).isBefore(shift.value.preCheckin)) {
      shift.patchValue({
        checkin: moment(event).format('HH:mm')
      });
    }
  }


  addShift() {
    const payload = this.shiftOverrideForm.value;
    this.driverService.addShiftOverride(payload, this.shiftId)
      .pipe(takeUntil(componentDestroyed(this))).subscribe(data => {
        if (data) {
          if (this.driverId) {
            this.router.navigateByUrl(`/credentialing/drivers/${this.driverId}/shift-override`)
          } else {
            this.router.navigateByUrl(`/timelines/shift-override`)
          }
        }
      })
  }

  onEnableShift(event) {
    const isOff = event.target.checked;
    const shift = this.shiftOverrideForm.get('shift') as FormGroup;

    if (isOff) {
      const date = moment().startOf('day');
      const start = date.clone().hour(0).minute(0);
      const end = date.clone().hour(23).minute(59);

      shift.patchValue({
        preCheckin: start.toISOString(),
        checkin: start.format('HH:mm'),
        preCheckout: end.toISOString(),
        checkout: end.format('HH:mm')
      });
    } else {
      shift.patchValue({
        preCheckin: moment().startOf('day').toISOString(),
        preCheckout: moment().endOf('day').toISOString(),
        checkin: moment().startOf('day').format("HH:mm"),
        checkout: moment().endOf('day').format("HH:mm"),
      });
    }
  }

  getMinDate() {
    return moment().startOf('day');
  }

  getMaxDate() {
    return moment().endOf('day');
  }

  ngOnDestroy(): void {
  }

}
